// AI Copy Generator (S024)
import React, { useState } from 'react';
import { useCopyGeneration } from '../hooks/useCopyGeneration';

interface Props {
  campaignId?: string;
  onCopyGenerated?: (copy: string) => void;
}

export const AICopyGenerator: React.FC<Props> = ({ campaignId, onCopyGenerated }) => {
  const [prompt, setPrompt] = useState('');
  const [tone, setTone] = useState('professional');
  const [length, setLength] = useState('medium');
  const { generate, isLoading, error } = useCopyGeneration();

  const handleGenerate = async () => {
    if (!prompt.trim()) return;
    const result = await generate({ prompt, tone, length, campaignId });
    if (result && onCopyGenerated) {
      onCopyGenerated(result.copy);
    }
  };

  return (
    <div className="bg-white dark:bg-boxdark rounded-lg p-6 border border-stroke dark:border-strokedark">
      <h3 className="font-semibold text-lg mb-4">✨ AI Copy Generator</h3>
      
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-2">What do you want to say?</label>
          <textarea
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            placeholder="e.g., Promote our winter sale with 30% off"
            className="w-full px-4 py-3 border border-stroke dark:border-strokedark rounded-lg"
            rows={3}
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-2">Tone</label>
            <select
              value={tone}
              onChange={(e) => setTone(e.target.value)}
              className="w-full px-4 py-2 border border-stroke dark:border-strokedark rounded-lg"
            >
              <option value="professional">Professional</option>
              <option value="casual">Casual</option>
              <option value="urgent">Urgent</option>
              <option value="friendly">Friendly</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">Length</label>
            <select
              value={length}
              onChange={(e) => setLength(e.target.value)}
              className="w-full px-4 py-2 border border-stroke dark:border-strokedark rounded-lg"
            >
              <option value="short">Short (50 chars)</option>
              <option value="medium">Medium (100 chars)</option>
              <option value="long">Long (200 chars)</option>
            </select>
          </div>
        </div>

        {error && (
          <div className="p-3 bg-red-50 border border-red-200 rounded text-red-700 text-sm">
            {error}
          </div>
        )}

        <button
          onClick={handleGenerate}
          disabled={isLoading || !prompt.trim()}
          className="w-full px-6 py-3 bg-primary text-white rounded-lg hover:bg-opacity-90 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLoading ? 'Generating...' : 'Generate Copy'}
        </button>
      </div>
    </div>
  );
};
